import NextImage from "@components/NextImage";
import SalesforceForm from "@components/Salesforce/SalesforceForm";
import {useTranslation} from "ni18n";
import React from "react";

const Contact: React.FC = () => {
  const i18n = useTranslation();
  return (
    <div id="get-started" className="bg-lightYellow pt30 pt14-sm pb60 pb20-xs ph8 pos-r">
      <div className="maxw80 ma df fdc-md zIndex1 pos-r">
        <div className="fx df jcc mr8 mb10-md">
          <div className="maxw26">
            <h2 className="fs48 fs32-xs mb5 mb2-xs">{i18n.t("Talk to our sales team")}</h2>
            <p className="fs28 fs22-sm fs16-xs font-ir-xs font-cm">
              {i18n.t(
                "Get in touch if you’re in charge of employee safety and want to learn more. We’ll respond within one business day.",
              )}
            </p>
          </div>
        </div>
        <div className="fx df jcfe jcc-md">
          <div className="bs2 hfc bg-white maxw28-sm maxw32 w100p">
            <SalesforceForm
              submitButtonLabel={i18n.t("Schedule a Demo")}
              channel="healthpass"
              trackingCategory="Carbon Healthpass"
            />
          </div>
        </div>
      </div>
      <div className="pos-a right0 bottom0 minh40-xs minw40-xs w100p h160">
        <NextImage src="/illustrations/squiggly-lines-yellow" layout="fill" alt="" />
      </div>
    </div>
  );
};

export default Contact;
